import { EditorPreviewCardGroup } from "@source-components-react/types";
import { cardEntries } from "./card-entries/card-entries";

export const cardGroups: EditorPreviewCardGroup[] = [
  {
    title: "Elements",
    showInitially: true,
    cards: [{ title: "Base Elements", entries: cardEntries }],
  },
];
